import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { IState } from 'models/reducers/i-state.interface';
import { ITopOffersTradePreviewDetails } from 'models/top-offers/i-top-offers';

import { refreshTopOffersUpdateTokenAction } from 'actions/top-offers.actions';

import CompleteCheckoutOfferModal from 'components/modal/completeCheckoutModal/CompleteCheckoutOfferModal';

import { useTopOffersEvents } from 'hooks/events/useTopOffersEvents';

import TopOffersNftCard from '../topOffersNftCard/TopOffersNftCard';

const TopOffersNftsSection = () => {
  const dispatch = useDispatch();
  const { offers } = useSelector((state: IState) => state.topOffers);
  const [isBuyModalVisible, setIsBuyModalVisible] = useState<boolean>(false);
  const [itemPreviewDetails, setItemPreviewDetails] = useState<ITopOffersTradePreviewDetails | undefined>(undefined);

  const topOffersBuyEvents = useTopOffersEvents();

  const onOpenModal = (itemPreviewDetails: ITopOffersTradePreviewDetails) => {
    setIsBuyModalVisible(true);
    setItemPreviewDetails(itemPreviewDetails);
  };

  const onCloseModal = () => {
    setIsBuyModalVisible(true);
    setItemPreviewDetails(undefined);
  };

  const onPurchaseFinished = () => {
    dispatch(refreshTopOffersUpdateTokenAction());
  };

  return (
    <>
      <div className="tw-flex tw-max-w-[820px] tw-flex-1 tw-flex-col tw-items-center tw-justify-center tw-gap-5 xl:tw-flex-row">
        {offers.map((offer) => (
          <TopOffersNftCard key={`top-offers-${offer.asset_id}`} offer={offer} onPurchase={onOpenModal} />
        ))}
      </div>
      {isBuyModalVisible && itemPreviewDetails && (
        <CompleteCheckoutOfferModal
          tradePreviewDetails={itemPreviewDetails}
          onClose={onCloseModal}
          onFinished={onPurchaseFinished}
          events={topOffersBuyEvents}
        />
      )}
    </>
  );
};

export default TopOffersNftsSection;
